import React, {
	useRef,
	useImperativeHandle,
	forwardRef,
	useEffect,
} from "react";

import Bar from "./Bar/Bar";
import Button from "../../../components/UI/Button/Button";
import ColorLegend from "../../../components/ColorLegend/ColorLegend";
import PlayControls from "../../../components/PlayControls/PlayControls";
import Dropdown from "../../../components/UI/Dropdown/Dropdown";
import sortingFunctions from "../../../utilities/sorting/sortingFunctions";

let Bars = (props, ref) => {
	const barsContainer = useRef();
	const invalid = useRef();
	const dropdown = useRef();
	const playControls = useRef();

	useImperativeHandle(ref, () => ({
		children: barsContainer.current.children,
		classList: barsContainer.current.classList,
		playControls: playControls.current,
	}));

	useEffect(() => {
		if (!invalid === undefined) console.log(invalid.current);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [invalid]);

	const handleChangedSort = (sort) => {
		props.changedSortingFunction(sort);
		dropdown.current.children[0].children[0].innerHTML = sort;
	};

	let sortingOptions = sortingFunctions.map((sortingFunction) => {
		return (
			<li
				key={sortingFunction}
				onClick={() => handleChangedSort(sortingFunction)}
			>
				{sortingFunction}
			</li>
		);
	});

	let bars;
	if (props.heights) {
		bars = props.heights.map((randHeight, i) => {
			return (
				<Bar
					key={i}
					height={randHeight}
					moreMargin={props.heights.length <= 50}
				>
					{props.showHeights && randHeight}
				</Bar>
			);
		});
	}
	return (
		<div className="bars-container">
			<Dropdown
				height={sortingFunctions.length * 3.3 + "rem"}
				ref={dropdown}
				defaultValue={"Merge Sort"}
				options={sortingOptions}
				changedSortingFunction={props.changedSortingFunction}
			></Dropdown>
			<div className="bars" ref={barsContainer}>
				{props.disableControls ? (
					<div className="invalid-inputs hide-invalid" ref={invalid}>
						<h1>Please place valid inputs</h1>
						<svg
							className="svg"
							id="f4dfef0e-e963-4752-8b60-16883a06d9db"
							data-name="Layer 1"
							xmlns="http://www.w3.org/2000/svg"
							width="1080.0487"
							height="748.00219"
							viewBox="0 0 1080.0487 748.00219"
						>
							<title>cancel</title>
							<path
								d="M832.20759,587.46822c0,67.693-40.24241,91.32887-89.88394,91.32887s-89.88394-23.63587-89.88394-91.32887,89.88394-153.80916,89.88394-153.80916S832.20759,519.77523,832.20759,587.46822Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#fa9f42"
							/>
							<polygon
								points="679.994 535.79 718.305 465.702 680.138 526.903 680.552 501.43 706.956 450.722 680.662 494.688 681.406 448.873 709.68 408.504 681.523 441.669 681.988 357.66 679.191 464.109 650.56 420.284 678.845 473.092 676.166 524.259 676.087 522.901 642.948 476.597 675.986 527.699 675.651 534.098 675.591 534.195 675.619 534.72 668.823 603 677.902 603 678.992 597.484 711.949 546.507 679.074 592.443 679.994 535.79"
								fill="#3f3d56"
							/>
							<path
								d="M1140.02435,369.81269c0,129.31047-76.873,174.46085-171.7007,174.46085s-171.7007-45.15038-171.7007-174.46085S968.32365,75.99891,968.32365,75.99891,1140.02435,240.50222,1140.02435,369.81269Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#f2f2f2"
							/>
							<polygon
								points="902.093 448.494 903.851 340.273 977.035 206.388 904.127 323.296 904.918 274.635 955.355 177.771 905.127 261.758 905.127 261.759 906.549 174.24 960.558 97.124 906.772 160.478 907.661 0 902.078 212.444 902.537 203.68 847.625 119.628 901.656 220.503 896.54 318.246 896.387 315.652 833.084 227.2 896.196 324.817 895.556 337.041 895.441 337.225 895.494 338.228 882.513 586.21 899.856 586.21 901.937 458.123 964.894 360.745 902.093 448.494"
								fill="#3f3d56"
							/>
							<path
								d="M1132.97565,640.5574c0,38.59549-250.36912,183.44369-543.05156,183.44369S59.97565,749.0362,59.97565,710.44071s231.44239,7.27952,524.12483,7.27952S1132.97565,601.96192,1132.97565,640.5574Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#3f3d56"
							/>
							<path
								d="M1132.97565,640.5574c0,38.59549-250.36912,183.44369-543.05156,183.44369S59.97565,749.0362,59.97565,710.44071s231.44239,7.27952,524.12483,7.27952S1132.97565,601.96192,1132.97565,640.5574Z"
								transform="translate(-59.97565 -75.99891)"
								opacity="0.1"
							/>
							<path
								d="M1132.97565,640.5574c0,38.59549-250.36912,139.76663-543.05156,139.76663S59.97565,749.0362,59.97565,710.44071,291.418,674.04316,584.10048,674.04316,1132.97565,601.96192,1132.97565,640.5574Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#3f3d56"
							/>
							<ellipse
								cx="535.87833"
								cy="641.77394"
								rx="225.04403"
								ry="17.40672"
								opacity="0.1"
							/>
							<path
								d="M417.57367,368.96457s65.88345,1.22006,53.68281,12.81067-57.953,0-57.953,0Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#a0616a"
							/>
							<path
								d="M280.30415,228.18183s26.60021-4.75031,35.84921,16.72359,28.244,82.71589,28.244,82.71589,50.83308,33.64785,60.079,32.54232,25.05178,1.15023,22.15247,11.2372-1.6122,21.52484-8.28694,22.92668-17.29058-11.97954-25.415-5.53421-80.53015-17.09648-85.17856-21.97431-43.27878-110.50134-43.27878-110.50134S266.01479,227.83769,280.30415,228.18183Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#fa9f42"
							/>
							<polygon
								points="277.379 605.607 280.429 631.228 254.808 637.939 240.167 631.228 240.167 608.657 277.379 605.607"
								fill="#a0616a"
							/>
							<polygon
								points="208.445 622.078 211.495 647.699 185.874 654.41 171.233 647.699 171.233 625.128 208.445 622.078"
								fill="#a0616a"
							/>
							<path
								d="M339.7946,401.60128l11.59061,42.0922L368.4661,529.098s4.88026,20.74108-4.88025,45.75239S336.13441,681.60593,339.7946,686.48618s-41.48217,8.54045-40.87214,3.66019,6.71036-71.98376,6.71036-71.98376,8.54044-59.1731,12.81067-66.49348-19.521-25.62134-19.521-25.62134-6.10031,70.15367-15.25079,76.254S275.74125,702.957,271.471,704.17711s-35.38185,6.10032-39.042,0,0-107.97565,0-107.97565,20.74108-77.47406,16.47086-88.45463-1.8301-57.953-1.8301-57.953-15.86083-35.99189-7.32038-54.90287Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#2f2e41"
							/>
							<path
								d="M337.96451,167.349s-25.62134,31.72166-24.40128,45.75239-40.26211-25.62134-40.26211-25.62134,29.89157-40.2621,29.89157-48.80255S337.96451,167.349,337.96451,167.349Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#a0616a"
							/>
							<circle
								cx="277.68384"
								cy="62.98363"
								r="40.26211"
								fill="#a0616a"
							/>
							<path
								d="M236.19284,378.78c-1.824,6.79577-4.08719,14.50047-3.76385,20.99122.20746,4.20313,11.36489,6.96045,26.79255,8.76616,14.30529,1.67758,32.283,2.53161,48.62569,2.97085,17.16021.46363,32.50245.46363,39.87779.46363,21.96115,0,4.27022-14.03074-4.27023-20.74109s-6.71035-101.87533-6.10031-114.076-5.49029-47.58249-5.49029-54.29285-14.35407-24.22438-14.35407-24.22438-3.33686,9.58362-16.75756-3.227-31.11163-16.47086-31.11163-16.47086c-13.4207,4.88025-35.99188,58.56306-37.21194,67.71354-.49417,3.71507-.08542,22.742.74422,44.46523,1.20174,31.75216,3.30029,69.2874,4.74606,73.27093C239.06,367.531,237.7973,372.80166,236.19284,378.78Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#fa9f42"
							/>
							<polygon
								points="241.387 338.413 245.657 353.664 229.186 370.745 223.696 346.953 241.387 338.413"
								fill="#a0616a"
							/>
							<path
								d="M306.85288,700.51692s12.81067,14.64076,22.57118,4.88025,9.15048-15.86083,10.98058-15.86083,29.28153,24.40128,29.28153,24.40128,46.97245,10.98057,21.35111,18.911-98.21513,2.44013-98.21513,0-1.8301-34.77182,4.88025-34.77182Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#2f2e41"
							/>
							<path
								d="M237.91927,716.98778s12.81067,14.64076,22.57118,4.88025,9.15048-15.86083,10.98058-15.86083,29.28153,24.40128,29.28153,24.40128,46.97246,10.98057,21.35112,18.911-98.21514,2.44013-98.21514,0-1.8301-34.77182,4.88025-34.77182Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#2f2e41"
							/>
							<path
								d="M292.45633,171.12178c-1.30065.84028-2.99385,1.69175-4.29617.85407a194.661,194.661,0,0,1-10.803-37.40333c-.82225-4.49515-1.393-9.49233,1.10424-13.3194.9849-1.50939,2.40274-2.74371,3.12416-4.39532,1.09254-2.50124.37345-5.39643.73641-8.10163.76042-5.66737,6.11775-9.62022,11.505-11.5373s11.23835-2.51176,16.37345-5.02733c4.87591-2.38861,8.78111-6.35,13.3025-9.35611s10.31287-5.0615,15.34812-3.03018c4.45436,1.797,7.229,6.33734,11.43921,8.64913,2.8571,1.5688,6.17272,2.00534,9.36187,2.67875a59.9218,59.9218,0,0,1,24.33972,11.30812,17.67252,17.67252,0,0,1,4.42964,4.56639c5.40289,8.8953-4.27062,20.98885-.00283,30.48113l-9.22662-7.28052a32.13074,32.13074,0,0,0-8.24035-5.237c-3.05623-1.15765-6.67559-1.29745-9.45179.42692-3.89609,2.42-4.95269,7.47582-6.3137,11.8557s-4.3705,9.23676-8.95561,9.12455c-6.23545-.15259-8.41611-8.85468-14.012-11.60979-3.6479-1.796-8.23962-.61324-11.34953,2.00618-3.10968,2.61923-4.97572,6.41973-6.34429,10.24826-.85526,2.39254-1.65774,5.08957-3.1768,7.16346-1.6754,2.28735-3.81829,2.47136-5.60773,4.17946C301.08225,162.81226,298.21838,167.39921,292.45633,171.12178Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#2f2e41"
							/>
							<path
								d="M236.19284,378.78c7.58272,10.99889,16.12928,22.34547,23.0287,29.75738,14.30529,1.67758,32.283,2.53161,48.62569,2.97085a38.52679,38.52679,0,0,0-10.75486-9.90691C289.162,396.721,270.251,338.768,270.251,338.768s23.18122-59.78313,29.28154-82.35431-17.69093-35.38185-17.69093-35.38185C270.861,211.88135,251.95,233.23247,251.95,233.23247s-9.65075,29.1107-18.7768,57.88593c1.20174,31.75216,3.30029,69.2874,4.74606,73.27093C239.06,367.531,237.7973,372.80166,236.19284,378.78Z"
								transform="translate(-59.97565 -75.99891)"
								opacity="0.1"
							/>
							<path
								d="M280.01148,216.15157s23.79124,12.81067,17.69092,35.38185-29.28153,82.35431-29.28153,82.35431,18.911,57.953,26.8414,62.83329,18.911,16.47086,10.37055,22.57118-14.64077,15.86083-20.74109,12.81067-6.10032-20.13105-16.47086-20.13105-52.46275-63.44332-53.07278-70.15367,34.77182-113.46594,34.77182-113.46594S269.0309,207.00109,280.01148,216.15157Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#fa9f42"
							/>
							<path
								d="M774.7215,382.89095l-6.8628-6.86279a21.34485,21.34485,0,0,0-30.18617,0L604.55734,509.14335,471.44215,376.02816a21.34485,21.34485,0,0,0-30.18617,0l-6.86279,6.86279a21.34484,21.34484,0,0,0,0,30.18618L567.50837,546.19232,434.39319,679.3075a21.34484,21.34484,0,0,0,0,30.18618l6.86279,6.86279a21.34485,21.34485,0,0,0,30.18617,0L604.55734,583.24128,737.67253,716.35647a21.34485,21.34485,0,0,0,30.18617,0l6.8628-6.86279a21.34486,21.34486,0,0,0,0-30.18618L641.60631,546.19232,774.7215,413.07713A21.34486,21.34486,0,0,0,774.7215,382.89095Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#ff6584"
							/>
							<path
								d="M429.6427,686.54463,558.80505,557.38235l-1.24334-1.24334L434.39317,679.30748A21.2598,21.2598,0,0,0,429.6427,686.54463Z"
								transform="translate(-59.97565 -75.99891)"
								opacity="0.1"
							/>
							<path
								d="M432.5526,387.21818a21.34488,21.34488,0,0,1,30.18621,0L595.854,520.33335,728.96915,387.21818a21.34488,21.34488,0,0,1,30.18621,0l6.86279,6.86279a21.34354,21.34354,0,0,1,4.75047,22.949l3.95289-3.95289a21.34479,21.34479,0,0,0,0-30.18614l-6.86279-6.86279a21.3449,21.3449,0,0,0-30.18621,0L604.55734,509.14331,471.44217,376.02814a21.3449,21.3449,0,0,0-30.18621,0l-6.86279,6.86279a21.2598,21.2598,0,0,0-4.75047,7.23715Z"
								transform="translate(-59.97565 -75.99891)"
								opacity="0.1"
							/>
							<path
								d="M642.84968,547.43565l-9.94669,9.9467L766.01815,690.49752a21.34356,21.34356,0,0,1,4.75047,22.94907l3.95289-3.953a21.34479,21.34479,0,0,0,0-30.18614Z"
								transform="translate(-59.97565 -75.99891)"
								opacity="0.1"
							/>
							<path
								d="M214.97565,636.19129c0,56.22159-33.42284,75.85206-74.652,75.85206s-74.652-19.63047-74.652-75.85206,74.652-127.7443,74.652-127.7443S214.97565,579.96971,214.97565,636.19129Z"
								transform="translate(-59.97565 -75.99891)"
								fill="#fa9f42"
							/>
							<polygon
								points="78.393 580.392 110.212 522.181 78.513 573.011 78.857 551.854 100.786 509.739 78.948 546.255 79.566 508.204 103.048 474.675 79.663 502.221 80.049 432.448 77.726 520.858 53.947 484.46 77.438 528.318 75.214 570.815 75.148 569.687 47.625 531.23 75.064 573.672 74.786 578.987 74.736 579.067 74.759 579.503 69.115 636.212 76.656 636.212 77.561 631.631 104.933 589.293 77.629 627.444 78.393 580.392"
								fill="#3f3d56"
							/>
						</svg>
						{}
					</div>
				) : (
					bars
				)}
			</div>
			<ColorLegend statuses={props.statuses} />
			<PlayControls
				ref={playControls}
				playClicked={() => {
					props.sort(props.sortConfig, props.heights);
				}}
				pauseClicked={() => props.pause(props.setTimeouts)}
				forwardStepClicked={() => props.stepped(props.setTimeouts, "+")}
				backwardStepClicked={() =>
					props.stepped(props.setTimeouts, "-")
				}
				paused={props.paused}
				disabled={props.disableControls}
				playText="Sort"
				pauseText="Pause"
				states={props.states}
				index={props.index}
				isSorting={props.isSorting}
			/>
			<Button
				className="burgundy new-array"
				clicked={props.generateNewArray}
				disabled={props.disableControls}
			>
				New Array
			</Button>
		</div>
	);
};

Bars = forwardRef(Bars);

export default Bars;
